module.exports = __webpack_public_path__ + "static/img/banner2.c8e5a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.jpg
// module id = y5LZ
// module chunks = 12